import React from 'react'
import cn from 'classnames'
import styles from './Toggle.module.scss'

const Toggle = ({selected, onChange, selectionTextOne, selectionTextTwo, className}) => {
  const classNames = cn(styles.toggle, className)

  return (
    <div className={classNames}>
      <div className={cn([styles.toggleSelection, selected && styles.selected])} onClick={onChange}>
        {selectionTextOne}
      </div>
      <div className={cn([styles.toggleSelection, !selected && styles.selected])} onClick={onChange}>
        {selectionTextTwo}
      </div>
    </div>
  )
}

export default Toggle
